var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.languages),function(lang){return _c('li',{key:lang,on:{"click":function($event){return _vm.changeLang(lang)}}},[_vm._v(_vm._s(lang))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }